import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../components/nav/Sidebar";
import "../App.css";
import "../styles/Sidebar.css";
import Dashboard from "../users/Dashboard";
import Transactions from "../users/Transactions";
import TransactionDetail from "../users/TransactionDetail";
import Transfer from "../users/Transfer";
import NewInvestment from "../pages/NewInvestment";
import PlanDetail from "../pages/PlanDetail";
import GetAdmin from "../admin/GetAdmin";
import MyCard from "../users/MyCard";
import Loans from "../pages/Loans";
import Profile from "../users/Profile";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Terms from "../pages/Terms";
import NotFound from "../pages/NotFound";
import UserDetail from "../admin/UserDetail";
import AddTransaction from "../admin/AddTransaction";
import TransactionLog from "../admin/TransactionLog";
import SkyFxt from "../users/SkyFxt";
import Special from "../users/Special";
import Escrow from "../users/Escrow";
import TradeTransactions from "../users/TradeTransactions";
import FxtDeposit from "../users/FxtDeposit";
import FxtWithdraw from "../users/FxtWithdraw";
import FxtTrade from "../users/FxtTrade";
import Wallets from "../admin/Wallets";
import Plans from "../admin/Plans";
import Buy from "../users/Buy";
import Accounts from "../admin/Accounts";
import BuyCoin from "../admin/BuyCoin";
import AdminFunding from "../admin/AdminFunding";

// Add ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}

const GetUser = ({ user }) => {
  return (
    <div>
      <>
        {user && (
          <>
            <Sidebar />
          </>
        )}

        {/* Add ScrollToTop component inside the Routes wrapper */}
        <ScrollToTop />

        <div className="vendorRoutes">
          {/* Define routes for different user views */}
          <Routes>
            <Route index element={<Dashboard user={user} />} />
            <Route path="transactions" element={<Transactions user={user} />} />
            <Route path="transactions/:userId/:index" element={<TransactionDetail user={user} />} />
            <Route
              path="login"
              element={<Navigate to="/" replace />}
            />
            <Route path="get-admin" element={<GetAdmin user={user} />} />
            <Route path="my-card" element={<MyCard user={user} />} />
            <Route path="transfer" element={<Transfer user={user} />} />
            <Route path="/investments/:planKey" element={<PlanDetail user={user} />} />
            <Route path="/investments" element={<NewInvestment user={user} />} />
            <Route path="fxt" element={<SkyFxt user={user} />} />
            <Route path="fxt/deposit" element={<FxtDeposit user={user} />} />
            <Route path="fxt/withdraw" element={<FxtWithdraw user={user} />} />
            <Route path="fxt/trade" element={<FxtTrade user={user} />} />
            <Route path="buy" element={<Buy user={user} />} />
            <Route path="fxt/transactions" element={<TradeTransactions user={user} />} />
            <Route path="loans" element={<Loans user={user} />} />
            <Route path="about-us" element={<About user={user} />} />
            <Route path="escrow" element={<Escrow user={user} />} />
            <Route path="special" element={<Special user={user} />} />
            <Route path="contact-us" element={<Contact user={user} />} />
            <Route path="terms" element={<Terms user={user} />} />
            <Route path="plans" element={<Plans user={user} />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="buy-coin" element={<BuyCoin />} />
            <Route path="admin-funding" element={<AdminFunding />} />
            <Route path="wallets" element={<Wallets user={user} />} />
            <Route
              path="userdetail/add-transaction"
              element={<AddTransaction user={user} />}
            />
            <Route path="user/:userId" element={<Profile user={user} />} />
            <Route
              path="userdetail/:userId"
              element={<UserDetail user={user} />}
            />
            <Route
              path="/userdetail/:userId/transactions"
              element={<TransactionLog />}
            />
            <Route path="*" element={<NotFound user={user} />} />
          </Routes>
        </div>
      </>
    </div>
  );
};

export default GetUser;
